<template>
  <de-layout-content>
    <div class="teamManage">
      <!-- <a-tabs v-model="activeKey">
        <a-tab-pane key="1" tab="运动队">
          <sport-team @operate="operate" />
        </a-tab-pane>
        <a-tab-pane key="2" tab="运动组">
          <sport-group @operate="operate"/>
        </a-tab-pane>
      </a-tabs> -->
    </div>
  </de-layout-content>
</template>

<script>
import sportTeam from "./sportTeam.vue";
import sportGroup from "./sportGroup.vue";


export default {
  data() {
    return {
      activeKey: "1",
    };
  },
  components: {
    sportTeam,
    sportGroup
  },
  methods: {
    operate(type) {
       console.log(type);
      if (type == "toGroup") {
        this.activeKey = "2";
      } else if(type === 'toManManage') {
        // 去到成员管理
        this.$router.push('/sportCenter/member');
      }
    },
  },
  created() {},
};
</script>
<style lang='less' scoped>
</style>
